import {
  SectionElement,
  defineElement,
  globalOn,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/new-video-accordion/new-video-accordion.ts
var NewVideoAccordion = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.activeIndex = 0;
    this.userPaused = false;
  }
  connectedCallback() {
    var _a;
    (_a = this.videoWraps) == null ? void 0 : _a.forEach((wrap, index) => {
      var _a2;
      (_a2 = wrap.querySelector("video")) == null ? void 0 : _a2.addEventListener("ended", () => {
        if (index === this.activeIndex)
          this.setActive(index + 1);
      });
    });
    this.setActive(0);
    this.startProgressLoop();
  }
  get activeVideo() {
    var _a, _b, _c;
    return (_c = (_b = (_a = this.videoWraps) == null ? void 0 : _a[this.activeIndex]) == null ? void 0 : _b.querySelector("video")) != null ? _c : null;
  }
  initSwiper() {
    var _a, _b;
    (_b = (_a = this.swiper) == null ? void 0 : _a.swiperInstance) == null ? void 0 : _b.on("slideChange", () => {
      var _a2, _b2, _c;
      const index = (_c = (_b2 = (_a2 = this.swiper) == null ? void 0 : _a2.swiperInstance) == null ? void 0 : _b2.realIndex) != null ? _c : 0;
      if (index !== this.activeIndex)
        this.setActive(index);
    });
  }
  onItemClick(elm) {
    const index = Number(elm.dataset.index);
    if (!Number.isNaN(index) && index !== this.activeIndex)
      this.setActive(index);
  }
  onDotClick(elm) {
    const index = Number(elm.dataset.index);
    if (!Number.isNaN(index) && index !== this.activeIndex)
      this.setActive(index);
  }
  togglePlay() {
    var _a, _b, _c;
    this.userPaused = !this.userPaused;
    if (this.userPaused)
      (_a = this.activeVideo) == null ? void 0 : _a.pause();
    else
      void ((_b = this.activeVideo) == null ? void 0 : _b.play().catch(() => {
      }));
    (_c = this.toggleButtons) == null ? void 0 : _c.forEach((button) => {
      button.setAttribute("data-playing", String(!this.userPaused));
    });
  }
  setActive(index) {
    var _a, _b, _c, _d, _e, _f, _g;
    const count = (_b = (_a = this.videoWraps) == null ? void 0 : _a.length) != null ? _b : 0;
    if (count === 0)
      return;
    const next = (index % count + count) % count;
    (_c = this.activeVideo) == null ? void 0 : _c.pause();
    this.activeIndex = next;
    this.style.setProperty("--nva-progress", "0");
    this.updateRing(0);
    (_d = this.items) == null ? void 0 : _d.forEach((item, i) => {
      item.setAttribute("data-active", String(i === next));
    });
    (_e = this.dots) == null ? void 0 : _e.forEach((dot, i) => {
      dot.setAttribute("data-active", String(i === next));
    });
    (_f = this.videoWraps) == null ? void 0 : _f.forEach((wrap, i) => {
      wrap.classList.toggle("opacity-0", i !== next);
      wrap.classList.toggle("pointer-events-none", i !== next);
    });
    const video = this.activeVideo;
    if (video) {
      video.currentTime = 0;
      if (!this.userPaused)
        void video.play().catch(() => {
        });
    }
    const swiperInstance = (_g = this.swiper) == null ? void 0 : _g.swiperInstance;
    if (swiperInstance && swiperInstance.realIndex !== next)
      swiperInstance.slideTo(next);
  }
  startProgressLoop() {
    const tick = () => {
      if (!this.isConnected)
        return;
      const video = this.activeVideo;
      if (video && video.duration > 0) {
        const progress = Math.min(video.currentTime / video.duration, 1);
        this.style.setProperty("--nva-progress", String(progress));
        this.updateRing(progress);
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }
  // Mobile ring: dash lengths as plain numbers (user units) set as attributes. Safari scales px-valued
  // dasharray/dashoffset with the page zoom and does not honour pathLength reliably, so no CSS calc here.
  updateRing(progress) {
    var _a, _b;
    const ring = (_b = (_a = this.videoWraps) == null ? void 0 : _a[this.activeIndex]) == null ? void 0 : _b.querySelector("[data-progress-ring]");
    if (ring == null)
      return;
    let length = Number(ring.dataset.length);
    if (!(length > 0)) {
      length = ring.getTotalLength();
      if (!(length > 0))
        return;
      ring.dataset.length = String(length);
    }
    ring.setAttribute("stroke-dasharray", String(length));
    ring.setAttribute("stroke-dashoffset", String(length * (1 - progress)));
    ring.style.opacity = progress > 0 ? "1" : "0";
  }
};
__decorateClass([
  query("[data-nva-swiper]")
], NewVideoAccordion.prototype, "swiper", 2);
__decorateClass([
  queryAll("[data-toggle-play]")
], NewVideoAccordion.prototype, "toggleButtons", 2);
__decorateClass([
  queryAll("[data-accordion-item]")
], NewVideoAccordion.prototype, "items", 2);
__decorateClass([
  queryAll("[data-video-wrap]")
], NewVideoAccordion.prototype, "videoWraps", 2);
__decorateClass([
  queryAll("[data-nva-dot]")
], NewVideoAccordion.prototype, "dots", 2);
__decorateClass([
  globalOn("new-video-accordion:init")
], NewVideoAccordion.prototype, "initSwiper", 1);
__decorateClass([
  onClick("[data-accordion-item]")
], NewVideoAccordion.prototype, "onItemClick", 1);
__decorateClass([
  onClick("[data-nva-dot]")
], NewVideoAccordion.prototype, "onDotClick", 1);
__decorateClass([
  onClick("[data-toggle-play]")
], NewVideoAccordion.prototype, "togglePlay", 1);
NewVideoAccordion = __decorateClass([
  defineElement("new-video-accordion")
], NewVideoAccordion);
export {
  NewVideoAccordion
};
